import { BasketComponent } from '@agent/core/basket/basket.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RouteSelector } from '@contact/upgrade';
import { TilesAgentDesktopFeatureQueuesInfosModule } from '@contact/tiles-agent-desktop-feature-queues-infos';

import { AgentDesktopComponent } from './agent-desktop.component';
import { AgentViewIndicatorsComponent } from './agent-view/indicators/agent-view-indicators.component';
import { AgentViewInformationComponent } from './agent-view/information/agent-view-information.component';
import { AgentCenterViewComponent } from './center-view/center-view.component';

export enum AgentDesktopState {
  ACTIVITY_MONITORING = 'activity-monitoring',
  BASKET = 'basket',
  BOOKING = 'booking',
  CENTER = 'center',
  INDICATORS = 'indicators',
  INFOS = 'infos',
  LAST_EXCHANGES = 'last-exchanges',
  RECORDS = 'records',
  QUEUES = 'queues',
}

export const AgentDesktopRouteParams = {
  IsConf: RouteSelector.params<boolean>('isConf'),
  GuestId: RouteSelector.params<string>('guestId'),
  ResponseId: RouteSelector.params<string>('respondeId'),
};

const routes: Routes = [
  {
    path: '',
    component: AgentDesktopComponent,
    children: [
      {
        path: AgentDesktopState.ACTIVITY_MONITORING,
        loadChildren: () =>
          import('@contact/tiles-agent-desktop-feature-activity-monitoring').then(m => m.TilesAgentDesktopFeatureActivityMonitoringModule),
      },
      {
        path: AgentDesktopState.BASKET,
        component: BasketComponent,
      },
      {
        path: AgentDesktopState.BOOKING,
        loadChildren: () => import('./contact-view/contact-view.module').then(m => m.ContactViewModule),
      },
      {
        path: AgentDesktopState.CENTER,
        component: AgentCenterViewComponent,
      },
      {
        path: AgentDesktopState.QUEUES,
        loadChildren: () => TilesAgentDesktopFeatureQueuesInfosModule,
      },
      {
        path: AgentDesktopState.INDICATORS,
        component: AgentViewIndicatorsComponent,
      },
      {
        path: AgentDesktopState.INFOS,
        component: AgentViewInformationComponent,
      },
      {
        path: AgentDesktopState.LAST_EXCHANGES,
        loadChildren: () =>
          import('@contact/tiles-agent-desktop-feature-last-exchanges').then(m => m.TilesAgentDesktopFeatureLastExchangesModule),
      },
      {
        path: AgentDesktopState.RECORDS,
        loadChildren: () => import('@contact/tiles-agent-desktop-feature-records').then(m => m.TilesAgentDesktopFeatureRecordsModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentDesktopRoutingModule {}
